<template>
  <sui-page>
    <sui-page-header
      :title="$t('MSG_TIT_DTM_COMP_STT')"
      :pageId="this.$options.name"
    />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="modules"
              :page-id="this.$options.name"
              :selected-md="selectData.moduleCode"
              :selected-smd="selectData.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TAB_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="tableName"
              placeholder=""
              maxlength="100"
              :disabled="false"
              :clearable="true"
              :readonly="false"
              @keyup.enter="searchTableList()"
              @keyup="onKeyUpInput($event,'termName')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NCOMP_DIV')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="nCompOptions"
              :selected="selectData.COD_NCOMP_DIV_CD"
              :pageId="this.$options.name"
              codeId="COD_NCOMP_DIV_CD"
              :disabled="false"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="resetSearch()"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="searchTableList()"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid2"
        :columns="gridColumns0"
        :enabletooltips="true"
        :showDisplayCountControl="false"
        :initialPagesize="10"
        :dataset="'dataset0'"
        @rowselect="onSelectRow"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="this.$options.name"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="excelDownload()"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_CDVAL_NCOMP_DTL') }}</h4>
      </div>
      <sui-grid
        ref="grid1"
        :columns="gridColumns1"
        :enabletooltips="true"
        :showDisplayCountControl="false"
        :initialPagesize="5"
        :dataset="'dataset1'"
      />
    </sui-page-contents>
  </sui-page>
</template>
<script>
export default {
  name: 'PGE_CMT_00012', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      tableName: '',
      // @Description: Search Box
      selectData: {
        // 선택된 select box 값
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
        COD_NCOMP_DIV_CD: { key: '', label: '' },
      },
      localdata0: [],
      localdata1: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'module',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModule',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_TAB_NM'),
        datafield: 'tableName',
      }, {
        text: this.$t('MSG_TXT_COMP_FLAG'),
        datafield: 'standardDateTimeObeyYn',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_NCOMP_CNT'),
        datafield: 'standardDateTimeNoncomplianceCount',
        width: 100,
        cellsalign: 'right',
      }],
      gridColumns1: [{
        text: this.$t('MSG_TXT_TAB_NM'),
        datafield: 'tableName',
      }, {
        text: this.$t('MSG_TXT_COL_NM'),
        datafield: 'columnName',
      }, {
        text: this.$t('MSG_TXT_DOMAIN_NAME'),
        datafield: 'domainName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_DOM_DSCR'),
        datafield: 'nonComplianceDescription',
      }, {
        text: this.$t('MSG_TXT_NON_COMP_VAL'),
        datafield: 'nonComplianceValue',
        width: 200,
      }],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  /* @Description: Dataset for grid */
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'module',
      type: 'string',
      map: 'module',
    }, {
      name: 'subModule',
      type: 'string',
      map: 'subModule',
    }, {
      name: 'tableName',
      type: 'string',
      map: 'tableName',
    }, {
      name: 'standardDateTimeObeyYn',
      type: 'string',
      map: 'standardDateTimeObeyYn',
    }, {
      name: 'standardDateTimeNoncomplianceCount',
      type: 'string',
      map: 'standardDateTimeNoncomplianceCount'
    }, {
      name: 'stdObyInspDt',
      type: 'string',
      map: 'stdObyInspDt',
    }],
  }, {
    id: 'dataset1',
    type: 'local',
    data: 'localdata1',
    datafields: [{
      name: 'tableName',
      type: 'string',
      map: 'tableName',
    }, {
      name: 'columnName',
      type: 'string',
      map: 'columnName',
    }, {
      name: 'domainName',
      type: 'string',
      map: 'domainName',
    }, {
      name: 'nonComplianceDescription',
      type: 'string',
      map: 'nonComplianceDescription',
    }, {
      name: 'nonComplianceValue',
      type: 'string',
      map: 'nonComplianceValue',
    }],
  }],
  methods: {
    resetSearch() {
      // this.$refs.modules.reset();
      this.selectData.moduleCode.key = 'ALL';
      this.selectData.subModuleCode.key = 'ALL';
      this.$refs.nCompOptions.reset();
      this.tableName = '';
    },
    /* @Description: Search Table Function */
    searchTableList() {
      // let oldData = [];
      //  if (this.dataset0.store.data) {
      // this.dataset0.store.data.forEach(row => {oldData.push(row)});
      // this.dataset0.store.data.splice(0, this.dataset0.store.data.length);
      //  }
      // this.dataset1.data = [];
      const queryParams = {};
      const fieldArray = {
        subModuleCode: this.selectData.subModuleCode.key,
        moduleCode: this.selectData.moduleCode.key,
        standardDateTimeObeyYn: this.selectData.COD_NCOMP_DIV_CD.key,
        tableName: this.tableName,
      };
      for(let key in fieldArray) {
        if (fieldArray[key] && fieldArray[key] != 'ALL') {
          queryParams[key] = fieldArray[key];
        }
      }
      http.request('PGE_CMT_00012', 'DTS_CMT_00069', {
        query: queryParams,
      }).then(res => {
        // if (res.data) {
        // res.data.forEach(row => {
        // this.dataset0.store.data.push(row);
        // });
        //  }
        this.dataset0.setRawData(res.data);
        console.log(this.dataset0);
      });
    },
    /* @Description: Row selection function */
    onSelectRow(target) {
      const queryParams = {
        stdObyInspDt: target.args.row.stdObyInspDt,
      };

      if (target.args.row.tableName) {
        http.request('PGE_CMT_00012', 'DTS_CMT_00071', {
          path: {
            'table-name': target.args.row.tableName,
          },
          query: queryParams,
        }).then(res => {
          this.dataset1.setRawData(res.data);
        }).catch(error => {
          this.console(error);
        });
      }
    },
    /* @Description: Excel download function */
    excelDownload() {
      const metaObj = {
        headerFontSize: 16,
        headerFontColor: 1,
        headerForegroundColor: 22,
      };

      const sPageId = this.$options.name;
      const objGridColumns = this.gridColumns0;
      const objGridDataset = this.dataset0;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `valid_date_compliance_table_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, metaObj);
    },
    /* @Description: special Charcter function */
    onKeyUpInput(event, name) {
      const searchFieldNewText = this.tableName;
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.tableName = this[name];
          // this.$refs[name].setFocus();
        });
      } else {
        this[name] = searchFieldNewText;
      }
    },
  },
};
</script>
<style scoped>
</style>
